import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { TourModalType } from '@/modules/onboarding/tour/models/TourOptions';
import LendaIcon from '@/components/commons/LendaIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingModal',
  props: {
    modalData: null,
    showDialog: { type: Boolean }
  },
  emits: ['closeModal'],
  setup(__props: any, { emit }) {

const props = __props as {
  modalData: Record<string, any>;
  showDialog?: boolean;
};





const logo = computed(() => {
  const logoName: string = props.modalData.modalType === TourModalType.FINISH
    ? 'finish' : 'default';
  return require(`../../assets/onboarding/onboarding_${logoName}_logo.svg`);
});

const closeModal = (data?: boolean) => {
  emit('closeModal', data);
};

return { __sfc: true,props, emit, logo, closeModal, LendaIcon }
}

})